import React, { useEffect, useState } from 'react';
import { MainContainer, MainHeading } from '../../style/GlobalStyles';
import { Box, Button, Card, CardContent, Grid, InputLabel, Link, OutlinedInput, Typography, useTheme } from '@mui/material';
import { useAuth } from '../../hooks/useAuth';
import { post } from '../../api';
import Modal from '../../components/Modal';
import { LoadingButton } from '@mui/lab';
import { MuiOtpInput } from 'mui-one-time-password-input';
import { set } from 'date-fns';

const CONSTANTS_JSON_DATA = {
    fullName: [
        {
            title: 'First Name',
            value: 'Aarun',
        },
        {
            title: 'Middle Name',
            value: '',
        },
        {
            title: 'last Name',
            value: 'Gunderson',
        },
    ],
    address: [
        {
            title: 'Street Address',
            value: 'testing street',
            width: '300px',
        },
        {
            title: 'City',
            value: 'xxx',
        },
        {
            title: 'State',
            value: 'xxx',
        },
        {
            title: 'Zip Code',
            value: '090909',
        },
    ],
    phoneNumber: [
        {
            title: 'Phone Number',
            value: '0999090000',
        },
    ],
    email: [
        {
            title: 'Email Address',
            value: 'aarun123456789@gmail.com',
        },
    ],
    password: [
        {
            title: 'Password',
            value: '099909Asdg5',
        },
    ],
};

const getProperName = (name = '') => {
    return name
        .replace(/([A-Z])/g, ' $1') // Add space before uppercase letters
        .trim() // Remove leading/trailing spaces
        .replace(/^./, (char) => char.toUpperCase()); // Capitalize the first letter
};

function AccountInfo() {
    const { getUserDetailsNotAsync, setUserDetailsNotAsync, refreshSessionData } = useAuth();
    let userDetails = getUserDetailsNotAsync();
    const theme = useTheme();

    const [contactInfo, setContactInfo] = useState(userDetails.contact);
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [currentEmail, setCurrentEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [otp, setOtp] = useState('');

    const handleNameSave = (data) => {
        userDetails.contact.firstName = data.firstName;
        userDetails.contact.middleName = data.middleName;
        userDetails.contact.lastName = data.lastName;
        userDetails.contact.name = data.firstName + ' ' + data.lastName;
        userDetails = { ...userDetails };
        setContactInfo(userDetails.contact);
        setUserDetailsNotAsync(userDetails);
        saveContact(userDetails.contact);
    };

    const handleAddressSave = (data) => {
        // userDetails.contact.mailingStreet = data?.streetAddress;
        userDetails.contact.mailingCity = data.city;
        userDetails.contact.mailingState = data.state;
        userDetails.contact.mailingPostalCode = data.zipCode;
        setContactInfo(userDetails.contact);
        setUserDetailsNotAsync(userDetails);
        saveContact(userDetails.contact);
    };

    const handlePhoneSave = (data) => {
        userDetails.contact.phone = data.phoneNumber;
        setContactInfo(userDetails.contact);
        setUserDetailsNotAsync(userDetails);
        saveContact(userDetails.contact);
    };

    const saveContact = (data) => {
        post('custom/updateContact', { contact: data }).then((result) => {
            if (!result.isSuccess) {
                console.log('Error in sending invitation');
            }
        });
    };

    const handleEmailSave = (data) => {
        if (data.email !== userDetails.contact.email) {
            setCurrentEmail(data.email);
            setIsOpenModal(true);
            post('otp/generateOTP', { memberId: userDetails.contact.id, email: data.email }).then((result) => {
                if (!result.isSuccess) {
                    console.log('Error in sending invitation');
                }
            });
        }
    };

    const handleModalClose = () => {
        setIsOpenModal(false);
        setCurrentEmail('');
        setOtp('');
        setContactInfo(userDetails.contact);
    };

    const handleVerify = () => {
        setLoading(true);
        post('otp/verifyOTP', { memberId: userDetails.contact.id, email: currentEmail, otp: otp }).then((result) => {
            if (result.isSuccess) {
                userDetails.contact.email = currentEmail;
                setContactInfo(userDetails.contact);
                setUserDetailsNotAsync(userDetails);
                handleModalClose();
                let messageDetail = { variant: 'success', message: 'Successfully updated the email' };
                const event = new CustomEvent('openToster', {
                    detail: messageDetail,
                });
                document.dispatchEvent(event);
            } else {
                console.log('Error in sending invitation');
                let messageDetail = { variant: 'error', message: 'Not a valid One-time Passcode' };
                const event = new CustomEvent('openToster', {
                    detail: messageDetail,
                });
                document.dispatchEvent(event);
                setOtp('');
            }
            setLoading(false);
        });
    };

    const handleOTPChange = (newValue) => {
        setOtp(newValue);
    };

    return (
        <>
            <MainContainer>
                <MainHeading>Account Information</MainHeading>

                <Box marginTop={'3.5rem'}>
                    {/* <Typography component={'h2'} variant='heading3'>
                        Contact Information
                    </Typography> */}

                    <Box marginTop={{ xs: '1.5rem', sm: '3rem' }} />

                    <FullNameForm
                        data={{
                            firstName: contactInfo.firstName,
                            middleName: contactInfo.middleName,
                            lastName: contactInfo.lastName,
                        }}
                        onSave={handleNameSave}
                    />

                    <Box marginTop={'2rem'} />

                    {/* <AddressForm
                        data={{ 
                            // streetAddress: contactInfo.mailingStreet,
                            city: contactInfo.mailingCity, state: contactInfo.mailingState, zipCode: contactInfo.mailingPostalCode }}
                        onSave={handleAddressSave}
                        userDetails={userDetails}
                    /> */}

                    <Box marginTop={'2rem'} />

                    <PhoneNumberForm data={{ phoneNumber: contactInfo.phone }} onSave={handlePhoneSave} />

                    <Box marginTop={'2rem'} />

                    <EmailForm data={{ email: contactInfo.email }} onSave={handleEmailSave} />
                </Box>

                <Box marginTop={'3rem'} marginLeft={'-1rem'} display={'flex'} flexDirection={'column'} justifyContent={'start'} alignItems={'start'}>
                    <Link underline="none" component={Button} href="/payment-information/payment-methods">
                        Update payment methods
                    </Link>
                    {/* <Link underline="none" component={Button} href="/">
                    Update Notification Settings
                </Link> */}
                </Box>
            </MainContainer>
            <Modal
                modalOpen={isOpenModal}
                title={'Enter your verification code'}
                hideActions={false}
                handleModalClose={handleModalClose}
                SubmitBtnUI={
                    <LoadingButton loading={loading} type="button" variant="contained" onClick={handleVerify}>
                        Verify
                    </LoadingButton>
                }
            >
                <Box
                    display={'flex'}
                    flexDirection={'column'}
                    sx={{
                        wordBreak: 'break-word',
                    }}
                >
                    <Typography
                        component={'p'}
                        color={theme.palette.text.primary}
                        fontSize={{
                            xs: theme.typography.customFontSize.medium,
                            sm: theme.typography.customFontSize.large,
                        }}
                        fontWeight={theme.typography.fontWeightRegular}
                        lineHeight={'normal'}
                        textAlign={{
                            xs: 'center',
                            sm: 'center',
                        }}
                        marginTop={{
                            sm: theme.typography.generic.xxLarge,
                            xs: theme.typography.generic.large,
                        }}
                    >
                        We have sent a 6-digit verification code to <strong> {currentEmail}</strong>
                    </Typography>
                </Box>

                <Box display={'flex'} sx={{ mt: '2rem' }} flexDirection={'column'} width={'100%'} justifyContent={'center'} alignItems={'center'}>
                    <MuiOtpInput
                        width={{
                            xs: '100%',
                            sm: '100%',
                            md: '95%',
                            lg: '80%',
                        }}
                        overflow={{
                            xs: 'auto',
                        }}
                        paddingBottom={'0.5rem'}
                        value={otp}
                        length={6}
                        onChange={handleOTPChange}
                        sx={{
                            gap: 'unset',
                            '&>*': {
                                marginRight: { xs: '2px !important', sm: '1rem !important' },
                            },
                            '&>*:last-child': {
                                marginRight: { xs: '0 !important' },
                            },

                            '& .MuiInputBase-input': {
                                padding: {
                                    xs: '14px 2px',
                                    sm: '16px 14px',
                                },
                            },
                        }}
                        TextFieldsProps={(index) => ({
                            inputProps: {
                                'aria-label': `otp text field ${index + 1}`,
                            },
                            sx: {
                                minWidth: '2.5rem',
                            },
                        })}
                    />
                </Box>
            </Modal>
        </>
    );
}

const FullNameForm = ({ data = {}, onSave }) => {
    const [formState, setFormState] = useState({});

    const [isEditable, setIsEditable] = useState(false);

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        setFormState((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleCancel = () => {
        setFormState({ ...data });
    };

    useEffect(() => {
        setFormState({ ...data });
    }, [data]);

    const handleSave = () => {
        onSave({ ...formState });
    };

    return (
        <Card sx={(theme) => ({})}>
            <CardContent>
                <Grid container spacing={2}>
                    {Object.keys(formState).map((cFormState) => (
                        <Grid
                            item
                            sx={{
                                width: {
                                    xs: '100%',
                                    sm: 'unset',
                                },
                            }}
                        >
                            <FormInputs name={cFormState} formState={formState} isEditable={isEditable} handleChange={handleChange} />
                        </Grid>
                    ))}

                    <Grid item display={'flex'} justifyContent={'center'} alignItems={'end'}>
                        <FormButtons isEditable={isEditable} onEditable={setIsEditable} handleCancel={handleCancel} onSave={handleSave} />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

const AddressForm = ({ data = {}, onSave = () => {}, userDetails = {} }) => {
    const [formState, setFormState] = useState({});

    const [isEditable, setIsEditable] = useState(false);

    // const [openModal, setOpenModal] = useState(false);

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        setFormState((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleCancel = () => {
        setFormState(data);
    };

    useEffect(() => {
        setFormState(data);
    }, [data]);

    const handleSave = () => {
        onSave(formState);
    };

    const handleEdit = (value) => {
        // createCase({
        //     subject: `Contact Support: Update Address`,
        //     title: `Contact Support`,
        //     subTitle: 'Add reason to Contact Support, that will help the agent.',
        //     recordType: 'General Case',
        //     accountId: userDetails?.contact?.accountId,
        // });
        createCase({
            title: `Request support—Update Address`,
            subTitle: 'Tell us a little more about how we can help you and an agent will contact you shortly!',
            subject: `Request support: Update Address`,
            recordType: 'General Case',
            accountId: userDetails?.contact?.accountId,
            hideCompanyField: true,
        });
    };

    // const handleModalClose = () => {
    //     setOpenModal(false);
    // };

    const createCase = (detail) => {
        const event = new CustomEvent('createCase', {
            detail: detail,
        });

        document.dispatchEvent(event);
    };

    return (
        <Card sx={(theme) => ({ border: `1px solid ${theme.palette.grey[300]}`, boxShadow: '0 0 2px 0 rgba(0, 0, 0, 0.08),0 4px 4px -4px rgba(0, 0, 0, 0.08)' })}>
            <CardContent>
                <Grid container spacing={2}>
                    {Object.keys(formState).map((cFormState) => (
                        <Grid
                            item
                            sx={{
                                width: {
                                    xs: '100%',
                                    sm: 'unset',
                                },
                            }}
                        >
                            <FormInputs
                                OutlinedInputProps={{
                                    sx: {
                                        width: {
                                            xs: '100%',
                                            sm: cFormState === 'streetAddress' ? '300px' : 'unset',
                                        },
                                    },
                                }}
                                name={cFormState}
                                formState={formState}
                                isEditable={isEditable}
                                handleChange={handleChange}
                            />
                        </Grid>
                    ))}
                    <Grid item display={'flex'} justifyContent={'center'} alignItems={'end'}>
                        <FormButtons isEditable={isEditable} onEditable={handleEdit} handleCancel={handleCancel} onSave={handleSave} />
                    </Grid>
                </Grid>
            </CardContent>
            {/* <Modal modalOpen={openModal} title={'Contact Support'} hideActions={true} handleModalClose={handleModalClose}>
                You can not update the address from here. Please contact support.
            </Modal> */}
        </Card>
    );
};

const PhoneNumberForm = ({ data = {}, onSave }) => {
    const [formState, setFormState] = useState({});

    const [isEditable, setIsEditable] = useState(false);

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        setFormState((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleCancel = () => {
        setFormState({ ...data });
    };

    useEffect(() => {
        setFormState({ ...data });
    }, [data]);

    const handleSave = () => {
        onSave({ ...formState });
    };

    return (
        <Card sx={(theme) => ({ border: `1px solid ${theme.palette.grey[300]}`, boxShadow: '0 0 2px 0 rgba(0, 0, 0, 0.08),0 4px 4px -4px rgba(0, 0, 0, 0.08)' })}>
            <CardContent>
                <Grid container spacing={2}>
                    {Object.keys(formState).map((cFormState) => (
                        <Grid
                            item
                            sx={{
                                width: {
                                    xs: '100%',
                                    sm: 'unset',
                                },
                            }}
                        >
                            <FormInputs name={cFormState} formState={formState} isEditable={isEditable} handleChange={handleChange} />
                        </Grid>
                    ))}
                    <Grid item display={'flex'} justifyContent={'center'} alignItems={'end'}>
                        <FormButtons isEditable={isEditable} onEditable={setIsEditable} handleCancel={handleCancel} onSave={handleSave} />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

const EmailForm = ({ data = {}, onSave }) => {
    const [formState, setFormState] = useState({});

    const [isEditable, setIsEditable] = useState(false);

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        setFormState((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleCancel = () => {
        setFormState(data);
    };

    useEffect(() => {
        setFormState(data);
    }, [data]);

    const handleSave = () => {
        onSave(formState);
    };

    return (
        <Card sx={(theme) => ({ border: `1px solid ${theme.palette.grey[300]}`, boxShadow: '0 0 2px 0 rgba(0, 0, 0, 0.08),0 4px 4px -4px rgba(0, 0, 0, 0.08)' })}>
            <CardContent>
                <Grid container spacing={2}>
                    {Object.keys(formState).map((cFormState) => (
                        <Grid
                            item
                            sx={{
                                width: {
                                    xs: '100%',
                                    sm: 'unset',
                                },
                            }}
                        >
                            <FormInputs
                                OutlinedInputProps={{
                                    sx: {
                                        width: {
                                            xs: '100%',
                                            sm: '300px',
                                        },
                                    },
                                }}
                                name={cFormState}
                                formState={formState}
                                isEditable={isEditable}
                                handleChange={handleChange}
                            />
                        </Grid>
                    ))}
                    {/* <Grid item display={'flex'} justifyContent={'center'} alignItems={'end'}>
                        <FormButtons isEditable={isEditable} onEditable={setIsEditable} handleCancel={handleCancel} onSave={handleSave} />
                    </Grid> */}
                </Grid>
            </CardContent>
        </Card>
    );
};

const FormButtons = ({ isEditable, onSave, onEditable = () => {}, handleCancel = () => {} }) => {
    return (
        <>
            {isEditable ? (
                <>
                    <Button
                        sx={{ padding: '10px 16px' }}
                        onClick={() => {
                            onSave();
                            onEditable(false);
                        }}
                    >
                        Submit
                    </Button>

                    <Button
                        color="error"
                        sx={{ padding: '10px 16px' }}
                        onClick={() => {
                            handleCancel();
                            onEditable(false);
                        }}
                    >
                        Cancel
                    </Button>
                </>
            ) : (
                <Button sx={{ padding: '10px 16px' }} onClick={() => onEditable(true)}>
                    Edit
                </Button>
            )}
        </>
    );
};

const FormInputs = ({
    OutlinedInputProps = {
        sx: {},
    },
    name = '',
    isEditable = false,
    formState = {},
    handleChange = () => {},
}) => {
    return (
        <>
            <InputLabel sx={{ marginBottom: '0.4rem' }}>{getProperName(name)}</InputLabel>
            <OutlinedInput
                name={name}
                disabled={!isEditable}
                inputProps={{
                    sx: {
                        padding: '10px 16px',
                    },
                }}
                sx={{
                    width: {
                        xs: '100%',
                        sm: 'unset',
                    },

                    ...OutlinedInputProps.sx,
                }}
                value={formState[name]}
                onChange={handleChange}
            />
        </>
    );
};

export default AccountInfo;
